import { Component, ElementRef, EventEmitter, HostListener, Input, NgZone, OnChanges, OnDestroy, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxSummernoteDirective, NgxSummernoteModule } from 'ngx-summernote';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { fromEvent, of, Subscription } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { JobService } from 'src/app/services/job.service';
import { ApiService } from '../../services/api.service';
import { AppSettings } from '../../services/AppSettings';
import { SocketService } from '../../services/socket.service';
import { UtilService } from '../../services/util.service';
declare var $: any;

import { SocketServiceStream } from 'src/app/services/SocketServiceStream';
import { CommonSkeletonComponent } from '../../skeleton/common-skeleton/common-skeleton.component';
import { FilterPipe } from '../../pipe/filter.pipe';
import { SortByDatePipe } from '../../pipe/SortByDatePipe';
import { TimezoneDatePipe } from '../../timezone-date.pipe';
import { MessageTimestampPipe } from '../../pipe/message-timestamp.pipe';
import { MessageuniquePipe } from '../../pipe/messageunique.pipe';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import Swal from 'sweetalert2';



@Component({
  selector: 'app-message-widget',
  standalone: true,
  imports: [BsDropdownModule, CommonModule, FormsModule, NgxSummernoteModule, InfiniteScrollModule,
CommonSkeletonComponent, FilterPipe, SortByDatePipe, TimezoneDatePipe, MessageTimestampPipe, MessageuniquePipe,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './message-widget.component.html',
  styleUrls: ['./message-widget.component.scss'],
})
export class MessageWidgetComponent implements OnInit, OnDestroy , OnChanges {
  @Input() messageDataPass: any;
  @Input() userData: any;
  // Embedded variant (candidate/job profile slider Chat tab): the widget
  // fills its parent pane instead of floating bottom-right, drops the purple
  // header + close button (the slider header/tab identify the person; the
  // tab switch is the exit), and re-skins thread + input to the v3 wireframe.
  // All chat logic (sockets, pagination, send/edit, gating) is unchanged.
  @Input() embedded = false;
  socketTopicmessageMSG11: Subscription;
  @Output() closeMessageModel: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(NgxSummernoteDirective) summernote: NgxSummernoteDirective;
  sendMessageData: any = {};
  listerData
  // config = {
  //   focus: true,
  //   placeholder: 'Enter message',
  //   toolbar: [],
  //   width: '80%'
  // };

  config = {
    focus: true,
    placeholder: 'Type a message',
    toolbar: [],
    width: '80%',
    minHeight: 40,  
    maxHeight: 66,
    callbacks: {
      onInit: function() {
        const $editor = $(this).next('.note-editor');
        $editor.find('.note-editable').css('overflow-y', 'auto');
      },
      // Media is not sendable from the mini chat (send strips attachments), so a
      // pasted image must never be base64-inlined either. The capture-phase
      // blockComposerMedia handler stops file pastes/drops before Summernote sees
      // them; this no-op catches anything that still reaches Summernote's image path.
      onImageUpload: () => {}
    }
  };
  messageList: any = [];
  pagination = 10;
  currentIndex = 0;
  url = AppSettings.photoUrl;
  // Image/video lightbox preview (mirrors the main message page's fancybox modal).
  fancyList: any = [];
  slideIndex = 1;
  loaderstartstop = true;
  toptobotom = false;
  @ViewChild('videoPlayer793') videoplayer793: ElementRef;
  @ViewChild('container') chartDisc: ElementRef;
  @ViewChildren("messageContainer") messageContainers: QueryList<ElementRef>;
  @ViewChild('container') container: ElementRef;
  @ViewChild("autofocusSendmsg") autofocusSendmsg;
  @ViewChild('chartDiscussion', { static: true }) _div: ElementRef;
  exits = false;
  disableSendmsg = false;

  // QA 2026-04-24 (Bug 1) — summernote wraps whitespace-only input as
  // `<p>&nbsp;&nbsp;</p>` / `<p>  </p>`, which sails past the template's
  // string-equality checks and lets the Send button stay enabled.
  // Strip tags + entities + whitespace before the `[disabled]` eval.
  // 2026-05-14 — after the first successful send `sendMessageData.message`
  // is reset to `{}` (object), so a non-string guard is required too;
  // otherwise `String({})` => "[object Object]" re-enables Send.
  get isMessageBlank(): boolean {
    const msg = this.sendMessageData?.['message'];
    if (msg == null || msg === '') return true;
    if (typeof msg !== 'string') return true;
    const stripped = msg.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim();
    return stripped.length === 0;
  }
  startCount = 0;
  pageCount = 7;
  currentPageCount = 0;
  userId = localStorage.getItem('userId');
  searchName: any;
  modalScrollDistance = 4;
  modalScrollThrottle = 100;
  searchAfterKeys = null;
  nodatafound = "No conversations yet"
  shownodatafound = false;
  editMessage: boolean = false
  editValue: any;
  FormData: any;
  scrollbarload: boolean = false;
  contactList: Array<any> = [];
  photo: any;
  authorPhoto: any;
  selectedUser;
  loginUserData;
  private subscription: Subscription = new Subscription();
  onlinestatus: Subscription;
  topicMessageSub: Subscription;
  topic_newcontacts_Subscribe: Subscription;
  topic_contacts_Subscribe: Subscription;
  streamsubscription: Subscription;
  private subscriptionsList: Subscription[] = [];
  constructor(private _socket: SocketService,private JobServicecolor: JobService, private util: UtilService, private api: ApiService,
    private streamService : SocketServiceStream, private ngZone: NgZone
  ) {
    $.extend($.summernote.plugins, {
      'brenter': function (context) {
        this.events = {
          'summernote.enter': function (we, e) {
            if ((e.which === 13 || e.keyCode === 13) && e.altKey) {
            } else if (e.which === 13 || e.keycode === 13) {
              $('#sendmsg').click();
              e.preventDefault();
            }
          }
        };
      }
    });
    this.onlinestatus=this.streamService.connect().pipe(
      switchMap(client => {
        if (!client.connected) {
          console.log('WebSocket is not connected');
          return of(null);
        } else {
          return this.streamService.onMessage('/topic/contacts/' + localStorage.getItem('userId'));
        }
      })
    ).subscribe(contact => {
      if (contact) {
        if (this.contactList.length === 0) {
          if (this.exitData && contact.groupId === this.exitData.groupId) {
            this.userData.online = contact.online ? "ONLINE" : "OFFLINE";
          }
        }
        else if (this.contactList.length > 0) {
          const updatedContactList = this.contactList.map((element) => {
            if (element.groupId === contact.groupId) {
              if (this.selectedUser !== undefined) {
                this.userData.online = contact.online === true ? 'ONLINE' : 'OFFLINE';
              }
              return {
                ...element,
                online: contact.online,
              };
            }
            return element;
          });
          this.contactList = updatedContactList;
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.messageDataPass){
      this.messageDataPass = changes.messageDataPass.currentValue;
      console.log("Sdusdstdftsuvdusg " , this.messageDataPass);
      this.messageDataPass.entityId=this.messageDataPass.jobReferenceId || this.messageDataPass.candidateReferenceId ;


      if(this.messageDataPass.removeConnection != undefined && this.messageDataPass.removeConnection){
        this.chatuserList();
      }
    }
  }

  resetToContactList(): void {
  if (!this.messageDataPass || this.messageDataPass.owner) { return; }
  this.messageDataPass.owner = true;
  this.messageDataPass.status = 'ACTIVE';
  this.messageDataPass.entitystatus = 'ACTIVE';
  this.messageList = [];
  this.pagination = 10;
  this.currentIndex = 0;
  this.searchAfterKeys = null;
  this.selectedUser = undefined;
  if (this.topicMessageSub) {
    this.topicMessageSub.unsubscribe();
  }
}

  Support:boolean=false
  ngOnInit() {

    // Zone-safe catch-all so a failed/abandoned drag never leaves the dropzone overlay stuck.
    this.registerDropzoneCatchAll();

    this.currentIndex = 0;
    this.searchAfterKeys = null;
    if (this.messageDataPass.owner) {
      this.chatuserList();
    } else {
      if(this.messageDataPass.onlySupport!=undefined && this.messageDataPass.onlySupport =="SUPPORT"){
        this.Support=true;
        this.loaderstartstop=false;
        if(this.messageDataPass.id){
           this.messageListget(this.messageDataPass);
        }

      }else{
        this.userDetails(null);
        this.messageListget(null);
      }

    }
    this.loginuser();

    setTimeout(() => {
      if (this.container && this.container.nativeElement) {
        const container: HTMLDivElement = this.container.nativeElement;
        fromEvent(container, 'scroll').subscribe((e: Event) => {
          if (e.target['scrollTop'] == 0) {
          }
        });
      }
    }, 2000);


  }



  loginuser() {
    this.api.query("user/" + localStorage.getItem('userId')).subscribe((res) => {
      if (res != undefined && res.code == "00000") {
        this.loginUserData = res;
      }
    });
  }
  getInitials(fullname: string): string {
    return this.JobServicecolor.getInitials(fullname);
  }

  getColor(fullname: string): string {
    return this.JobServicecolor.getColor(fullname);
  }
  getFullNameTextColor(fullname: string): string {
    return this.JobServicecolor.getFullnameTextColor(fullname);
  }
   // for first and last name
  getInitialName(firstname: string,lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname,lastname);
  }
   // for first and last name
   getColorName(firstname: string,lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname,lastname);
  }
  getTextColor(firstname: string,lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname,lastname);
  }

  /**
   * Get the full photo URL, avoiding duplication if the photo already contains the base URL
   */
  getPhotoUrl(photo: string): string {
    if (!photo) {
      return '';
    }
    // If photo already starts with http/https, return as-is
    if (photo.startsWith('http://') || photo.startsWith('https://')) {
      return photo;
    }
    // Otherwise, prepend the base URL
    return this.url + photo;
  }

  // Open the image/video lightbox for the clicked attachment, mirroring the main
  // message page. Uses widget-scoped DOM ids (myModalWidget / mySlidessWidget) so it
  // never collides with the full message page's fancybox when both exist in the DOM.
  showImageAndVideoPreview(item: any, i: any) {
    const modal = document.getElementById('myModalWidget');
    if (modal) { modal.style.display = 'block'; }
    this.fancyList = item['attachments'];
    setTimeout(() => {
      this.showSlides(i + 1);
    }, 100);
  }

  // Esc closes the lightbox — a safety net so the user is never stuck if the
  // close button is ever obscured.
  @HostListener('document:keydown.escape')
  onEscapeKey() {
    const modal = document.getElementById('myModalWidget');
    if (modal && modal.style.display === 'block') {
      this.closeFancyModal();
    }
  }

  // Summernote shows its "Drag image or text here" overlay by adding a `.dragover` class
  // to `.note-editor` on dragenter, tracked by an internal drag counter it only resets on
  // its OWN clean drop / dragleave-to-<body>. When a drag ends any other way (dropped
  // outside, Esc-cancelled, imbalanced enter/leave) that counter stays stuck non-empty, so
  // the overlay hangs AND the next drag won't re-show it or accept a drop. Just removing the
  // CSS class isn't enough — the counter is still stuck. We dispatch a dragleave on <body>
  // so Summernote's own handler resets the counter and drops the class, keeping drag-drop
  // working for subsequent attempts. (Mirrors new-message-page; same editor.)
  private resettingDropzone = false;
  private dropzonePending = false;

  private resetSummernoteDropzone() {
    if (this.resettingDropzone) { return; } // guard: our synthetic event re-enters below
    this.resettingDropzone = true;
    // target === <body> is the condition Summernote's onDragleave uses to reset its counter.
    document.body.dispatchEvent(new Event('dragleave', { bubbles: true }));
    $('.note-editor.dragover').removeClass('dragover');
    this.resettingDropzone = false;
  }

  @HostListener('window:drop')
  @HostListener('window:dragend')
  clearSummernoteDropzone() {
    this.dropzonePending = false;
    this.resetSummernoteDropzone();
  }

  // A drag that leaves the browser window fires no drop; clear on window-exit dragleave.
  @HostListener('window:dragleave', ['$event'])
  onWindowDragLeave(event: DragEvent) {
    if (this.resettingDropzone) { return; } // ignore our own synthetic dragleave
    if (!event.relatedTarget && (event.clientX <= 0 || event.clientY <= 0 ||
      event.clientX >= window.innerWidth || event.clientY >= window.innerHeight)) {
      this.dropzonePending = false;
      this.resetSummernoteDropzone();
    }
  }

  // Catch-all for drags that end WITHOUT firing drop/dragend/window-exit dragleave — e.g.
  // dragging text/an image from OUTSIDE the page and releasing it on a non-drop-target
  // (no drop fires, no in-page source for dragend). HTML5 drags suppress mouse events, so
  // the first mousemove after a drag means it's over — clear then. Registered OUTSIDE the
  // Angular zone so the frequent mousemove/dragenter never trigger change detection.
  private onDocDragEnter = () => { this.dropzonePending = true; };
  private onDocMouseMove = () => {
    if (this.dropzonePending) {
      this.dropzonePending = false;
      this.resetSummernoteDropzone();
    }
  };

  // Image/video/file paste and drop are BLOCKED in the mini chat: the widget's
  // send strips attachments anyway, so an inlined image would silently vanish on
  // send — refusing it up front is honest. Capture phase, so Summernote never
  // sees the file (it would base64-inline it). Text pastes pass through untouched.
  private blockComposerMedia = (e: any) => {
    const t: any = e.target;
    if (!t || !t.closest || !t.closest('.containerChat793')) { return; }
    const files = (e.clipboardData && e.clipboardData.files) || (e.dataTransfer && e.dataTransfer.files);
    if (!files || !files.length) { return; }
    e.preventDefault();
    e.stopPropagation(); // also skips the window:drop overlay reset, so:
    this.ngZone.run(() => {
      this.resetSummernoteDropzone();
      Swal.fire({
        text: "Images and videos can't be sent from this chat. Please use the Messages page.",
        icon: 'info',
        timer: 2500,
        showConfirmButton: false
      });
    });
  };

  private registerDropzoneCatchAll() {
    this.ngZone.runOutsideAngular(() => {
      window.addEventListener('dragenter', this.onDocDragEnter);
      document.addEventListener('mousemove', this.onDocMouseMove);
    });
    document.addEventListener('paste', this.blockComposerMedia, true);
    document.addEventListener('drop', this.blockComposerMedia, true);
  }

  private unregisterDropzoneCatchAll() {
    window.removeEventListener('dragenter', this.onDocDragEnter);
    document.removeEventListener('mousemove', this.onDocMouseMove);
    document.removeEventListener('paste', this.blockComposerMedia, true);
    document.removeEventListener('drop', this.blockComposerMedia, true);
  }

  closeFancyModal() {
    const slides = document.getElementsByClassName('mySlidessWidget');
    for (let i = 0; i < slides.length; i++) {
      slides[i]['style'].display = 'none';
    }
    const modal = document.getElementById('myModalWidget');
    if (modal) { modal.style.display = 'none'; }
    this.slideIndex = 1;
  }

  toggleVideo(event?: any) {
    if (this.videoplayer793 && this.videoplayer793.nativeElement) {
      this.videoplayer793.nativeElement.play();
    }
  }

  plusSlides(n) {
    this.showSlides(this.slideIndex += n);
  }

  currentSlide(n) {
    this.showSlides(this.slideIndex = n);
  }

  showSlides(n) {
    this.slideIndex = n;
    const slides = document.getElementsByClassName('mySlidessWidget');
    if (!slides.length) { return; }
    if (n > slides.length) { this.slideIndex = 1; }
    if (n < 1) { this.slideIndex = slides.length; }
    for (let i = 0; i < slides.length; i++) {
      slides[i]['style'].display = 'none';
    }
    slides[this.slideIndex - 1]['style'].display = 'block';
  }

  backchat(values) {

    this.messageDataPass.owner = true;
    this.messageDataPass.status='ACTIVE';
    this.messageDataPass.entitystatus='ACTIVE';
    this.messageList = [];
    this.pagination = 10;
    this.currentIndex = 0;
    this.searchAfterKeys = null;
    this.contactList.forEach((element, i) => {
      if (element.groupId == values.recipientId) {
        element.nonSeenCount = 0;
      }
    });

    if (this.topicMessageSub) {
      this.topicMessageSub.unsubscribe();
    }


  }

  specfiuser(item) {

    this.messageDataPass.owner = false;
    this.messageDataPass.recipientId = item.groupId;
    this.messageDataPass.id = item.refererId;
    this.messageDataPass.entityId = item.entityId;
    if(item.groupType=='SUPPORT'){
      this.messageDataPass.id = item.groupId;
    }

    this.messageDataPass.groupType = item.groupType;
    this.messageDataPass.messageType = item.groupType;
    this.userDetails(item);
    this.messageListget(item);
    item.id = item.refererId;
    this.selectedUser = item;
  }

  previousEmit : any = {};
  public chatuserList() {
    this.loaderstartstop = true;
    let data: any = {}
    data.userId = localStorage.getItem('userId');
    data.groupType = "JOB,CANDIDATE,SUPPORT";

    if (this.messageDataPass.owner) {
      if (this.messageDataPass.groupType == "JOB" && this.messageDataPass.id != null) {
        data.groupType = "JOB";
      } else if (this.messageDataPass.groupType == "CANDIDATE" && this.messageDataPass.id != null) {
        data.groupType = "CANDIDATE";
      }
    }
    data.refererId = this.messageDataPass.id;

    let url = "findContactsByRefererId";
    this.api.messagePageService('POST', url, data).subscribe(res => {

      // Only the floating bottom chat (bottomChat flag, set in index-layout) also loads
      // the direct USER-to-USER contacts (restored from release-20250430) and MERGES them
      // into the list. Every other entry point that opens this widget in owner mode
      // (cards, sliders, nav-bar, viewed-by, applicants, ...) keeps the single-API
      // behaviour and is NOT affected by this restore.
      if (this.messageDataPass.bottomChat) {
        let userContactUrl = "message/new/contact/" + localStorage.getItem('userId');
        this.api.messagePageService('GET', userContactUrl).subscribe(userRes => {
          this.loaderstartstop = false;

          // Tag the direct user contacts as USER-type so the thread opens as a user chat.
          let combainedData = [];
          if (userRes && userRes.length != 0) {
            combainedData = userRes;
            combainedData.forEach(elements => {
              elements.groupType = "USER";
              elements.messageType = "USER";
            });
          }

          if (res && res.length > 0) {
            res.forEach(element => {
              if (element.lastMessageOn == null) {
                element.lastMessageOn = element.createdOn;
              }
            });
            this.contactList = this.sortBy(res, 'lastMessageOn');
            this.contactList = this.duplicate(this.contactList);
            this.contactList = this.contactList.concat(combainedData);
          } else {
            this.contactList = combainedData;
          }
        });
      } else {
        // Non-bottom-chat owner views: single-API behaviour (unchanged).
        this.loaderstartstop = false;
        if (res && res.length > 0) {
          res.forEach(element => {
            if (element.lastMessageOn == null) {
              element.lastMessageOn = element.createdOn;
            }
          });
          this.contactList = this.sortBy(res, 'lastMessageOn');
          this.contactList = this.duplicate(this.contactList);
        } else {
          this.contactList = [];
        }
      }




      this.topic_newcontacts_Subscribe = this._socket.onMessage('/topic/newcontacts/' + localStorage.getItem('userId')).subscribe((contact) => {
        //'topic/newcontacts', contact);

        var dateOne = new Date(contact.lastMessageOn); //Year, Month, Date
        var dateTwo = new Date(contact.lastModifiedOn); //Year, Month, Date


        if (dateOne > dateTwo) {
        } else { contact.lastMessageOn = contact.lastModifiedOn; }

        this.api.query("user/" + contact.createdBy).subscribe((ures) => {
          if (ures != undefined && ures.code == "00000") {
            contact.groupName = ures.firstName + " " + ures.lastName;

            contact.nonSeenCount = contact.nonSeenCount + 1;
            this.contactList.push(contact);
            this.contactList = this.sortBy(this.contactList, 'lastMessageOn');
            let data: any = {};
            data = this.duplicate(this.contactList);
            this.contactList = data;
          }
        });
      });
      this.topic_contacts_Subscribe=this._socket.connect().pipe(
        switchMap(client => {
          if (!client.connected) {
            console.log('WebSocket is not connected');
            return of(null);
          } else {
            return this._socket.onMessage('/topic/contacts/' + localStorage.getItem('userId'));
          }
        })
      ).subscribe(contact => {
        if (contact) {
          this.contactList.forEach((element, i) => {
                if (this.previousEmit && this.isMatchable(this.previousEmit, contact)) {
                  if (element.groupId === contact.groupId) {
                    contact.groupName = element.groupName;
                    element.lastMessageOn = contact.lastMessageOn;
                    element.nonSeenCount = element.nonSeenCount + 1;

                    this.previousEmit = contact;
                  }
                }
              });

              this.contactList = this.sortBy(this.contactList, 'lastMessageOn');
        }
      });

    });

  }

  isMatchable(previousEmit: any , data : any) : boolean{
    return (
      previousEmit.online != data.online ||
     previousEmit.lastMessageOn != data.lastMessageOn ||
     previousEmit.groupName != data.groupName );
  }


  duplicate(data) {
    var temp = [];
    var arr = data.filter(function (el) {
      // If it is not a duplicate, return true
      if (temp.indexOf(el.groupId) == -1) {
        temp.push(el.groupId);
        return true;
      }
      return false;
    });
    return arr;
  }

  sortBy(list: Array<any>, prop: string) {
    if (list != null && list.length > 0) {
      return list.sort((a, b) => {
        if (a.lastMessageOn == "null") {
          a[prop] = new Date();
          return <any>new Date(b[prop]) - <any>new Date(a[prop]);
        } else {
          return <any>new Date(b[prop]) - <any>new Date(a[prop]);
        }
      });
    }
  }

  private updateScoll() {
    if (!this.container) return;
    setTimeout(() => {
      if (this.container && this.container.nativeElement) {
        const container: HTMLDivElement = this.container.nativeElement;
        container.scrollTop = container.scrollHeight;
      }
    }, 0);
  }



  exitData !: any;
  messageListget(values) {
    this.loaderstartstop = true;

    let contact: any = {
      userId: localStorage.getItem('userId'),
      // groupId: this.messageDataPass.userId,
      groupType: this.messageDataPass.groupType,
      messageType: this.messageDataPass.messageType,
      refererId: this.messageDataPass.id
    };


    if (values != undefined && values.groupType != "USER") {
      contact.userId = values.createdBy
      contact.groupType = values.groupType
      contact.messageType = values.groupType
      contact.refererId = values.refererId

      if(contact.groupType=='SUPPORT'){
        contact.refererId = this.messageDataPass.id;
        contact.groupId = this.messageDataPass.id;
         contact.userId = values.userId;
      }

    } else if (values != undefined && values.groupType == "USER") {

      contact.userId = values.userId
      contact.groupType = values.groupType
      contact.messageType = values.groupType
      contact.groupId = values.groupId
      contact.refererId = values.groupId
    }
    // if(this.messageDataPass.groupType=="USER" && values == null){
    //   contact.groupId= this.messageDataPass.userId
    // }

    if(this.messageDataPass.onlyuser!=undefined &&this.messageDataPass.onlyuser=="USER"){
      contact.groupId= this.messageDataPass.userId
    }

    let url = "message/contact/exist";
    // this.util.startLoader('msgspinner');
    this.api.messagePageService('POST', url, contact).subscribe(res => {
      // this.util.stopLoader('msgspinner');

      this.loaderstartstop = false;
      this.exitData = res;

      // Not-connected guard: the backend returns code 99999 ("User is not present
      // in your connection list!..") when this USER is neither an existing contact
      // nor a connection. Honor it here - otherwise the send box stays enabled and
      // the user can message a non-connection. Mirror the blocked-state handling by
      // marking the contact INACTIVE (hides the input form) and disabling send.
      if (res?.code === '99999') {
        this.messageDataPass.status = 'INACTIVE';
        this.disableSendmsg = true;
        return;
      }

      if( res?.status){
        this.messageDataPass.status = res?.status;
      }
       this.messageDataPass.entitystatus = res.entitystatus;
      this.exits = res['exist'];
      if (res['exist'] || res['groupType']=="SUPPORT" && res.groupId!=undefined &&  res.groupId!=null) {

        if (values != null && values.nonSeenCount > 9) {
          this.toptobotom = true;
        }
        this.messageListQuery(res.groupId, "firstTime", values);
        this.messageDataPass.recipientId = res.groupId;
        setTimeout(() => {
          this.updateScoll();
        }, 1000);

        if (res['status'] == 'GROUP_INACTIVE') {
          this.disableSendmsg = true;
        } else {
          this.disableSendmsg = false;
        }

      } else {
        if (this.messageDataPass.groupType != "USER") {
          this.messageDataPass.recipientId = null;

        }
      }
      if (this.messageDataPass.groupType == "USER") {
        this.topic_message_recive(res)
      } else {
        this.topic_message_recive(res)
      }

    });


  }

  topic_message_recive(res) {

    if (this.messageDataPass.groupType == "USER") {
      res.groupId = res.groupId + '-' + localStorage.getItem('userId')
    }


    if (res.groupId != null) {
      this.socketTopicmessageMSG11 = this._socket.onMessage('/topic/event/' + localStorage.getItem('userId')).subscribe(res_evn => {
        console.log( this.socketTopicmessageMSG11);
        if(res_evn.status){
          this.messageDataPass.status=res_evn.status;
        }
        this.messageDataPass.entitystatus=res_evn.entitystatus;
      });
      this.topicMessageSub = this._socket.onMessage('/topic/message/' + res.groupId).subscribe(res => {
         if (res.eventType == "ACTION") {
          if (res.actionType == "DEACTIVATED") {
           this.messageDataPass.status="DEACTIVATED"
            this.disableSendmsg = true;
          } else {
            this.disableSendmsg = false;
            this.messageDataPass.status="ACTIVE"
          }
        }


        this.api.query("user/" + res.authorId).subscribe((response) => {
          if (response != undefined && response.code == "00000") {
            res.authorName = response.firstName + " " + response.lastName;
            // BUGFIX 2026-07-14: `response` IS the author's user record
            // (user/{authorId}) — use its photo for EVERY group type. The
            // old code below defaulted to the LOGGED-IN user's photo and
            // only the USER/JOB branches corrected it, so live incoming
            // messages in CANDIDATE chats rendered with the viewer's own
            // avatar until a reload re-mapped from history. An authorless
            // photo stays undefined → template's initials fallback.
            //
            // res.authorPhoto = this.loginUserData.photo;
            // if (res.userType == 'USER') {
            //   res.authorPhoto = response.photo;
            // }else if(res.userType == "JOB"){
            //   res.authorPhoto = response.photo;
            // }
            res.authorPhoto = response.photo;

            if (res.action == "UPDATE") {
              let index = this.messageList.findIndex(item => item.messageId === res.messageId)
              if (res.deleted) {
                this.messageList[index].message = "This message was deleted";
              } else {
                this.messageList[index].message = res.message;
              }
              console.log("MESSAGE UPDATED " , this.messageList[index] , res);

            } else {
              this.messageList.push(res);

              if (!this.messageDataPass.owner) {
                this.updateNonSeenMessage(this.messageList);
              }
              this.updateScoll();
            }

          }
        });

        this.updateScoll();

      });
      // this.subscriptionsList.push(this.topicMessageSub);
    }
  }


  messageListQuery(gpid, scrollLoad, values) {
    this.loaderstartstop = true;
    this.scrollbarload = true;
    let url = "messages";
    let msg: any = {
      authorId: localStorage.getItem('userId'),
      recipientId: gpid,
      refererId: this.messageDataPass.id,
      groupId: this.messageDataPass.userId,
      groupType: this.messageDataPass.groupType,
      messageType: this.messageDataPass.messageType,
      page: this.currentIndex,
      limit: this.pagination,
      searchAfterKey: this.searchAfterKeys,
    };

    if (this.toptobotom) {
      msg.page = 0,
        msg.limit = values.nonSeenCount

    }
    this.editMessage = false;
    // this.util.startLoader('msgspinner');
    this.api.messagePageService('POST', url, msg).subscribe(res => {
      // this.util.stopLoader('msgspinner');

      if (res) {
        this.loaderstartstop = false;
        if (res.data.messagesList != null) {
          let msgList = res.data.messagesList;
          this.searchAfterKeys = res.data.searchAfterKey;
          this.updateNonSeenMessage(msgList);
          if (msgList && msgList != null && msgList.length > 0) {
            msgList.forEach(element => {
              element.justSendmsg = false;
              if (element.deleted == true) {
                element.message = 'This message was deleted';
              }
              this.messageList.push(element);

              if (scrollLoad == "firstTime") {
                this.updateScoll();
              }

              if (this.toptobotom) {
                this.toptobotom = false;
                setTimeout(() => {
                  this.chartDisc.nativeElement.scroll({
                    behavior: "smooth", block: "top", inline: "nearest"
                  });
                  // const id = res.data.messagesList[0].messageId;
                  //     const element = document.getElementById(id);



                }, 400);

              }


            });
          }
        }

        if (this.messageList.length == 0) {
          this.shownodatafound = true
        } else {
          this.shownodatafound = false
        }

      }
    });
  }

  delete(item) {
    // Confirm before deleting — mirrors the message page's per-message delete
    // (new-message-page delete()): bootstrap buttons, Yes/No, reversed.
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons.fire({
      title: 'Are you sure you want to delete this message?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteMessageConfirmed(item);
      }
    });
  }

  deleteMessageConfirmed(item) {
    var url = "deleteMessages";
    var temp = [];
    temp.push(item);

    // this.util.startLoader('msgspinner');
    this.api.messagePageService('POST', url, temp).subscribe(res => {
      // this.util.stopLoader('msgspinner');

      this.messageList.forEach(element => {
        if (element.messageId == item.messageId) {
          element.message = "This message was deleted";
          element.deleted = true;
          element.enableDelete = false;
          element.attachments = null;
        }
      });
    }, err => {
      this.util.stopLoader();
    })
  }

  edit(item) {
    this.editMessage = true;
    this.editValue = item;
    this.sendMessageData['message'] = item.message;
    // Activate the compose editor on Edit — the ⋮ menu click leaves focus on the
    // (closing) menu item, so the field would otherwise show the text with no cursor.
    // setTimeout lets ngModel push the message into the editor first.
    setTimeout(() => this.focusComposeBox(), 50);
  }

  focusComposeBox() {
    try {
      ($('.message-input793') as any).summernote('editor.focus');
    } catch (e) { }
  }

  updateMsg() {
    var url = "updateEditedMessage";
    // this.util.startLoader('msgspinner');
    this.editValue.message = this.sendMessageData['message'];
    this.FormData = new FormData();

    this.FormData.append('message', new Blob([JSON.stringify(this.editValue)],
      {
        type: "application/json"
      }));
    this.api.messagePageService('POST', url, this.FormData).subscribe(res => {
      // this.util.stopLoader('msgspinner');

      this.editMessage = false;
      this.messageList.forEach(element => {
        if (element.messageId == this.editValue.messageId) {
          element.message = this.editValue.message;;
          this.summernote.writeValue('');
          this.editValue = "";
          element.enableDelete = true;
        }
      });
    }, err => {
      this.util.stopLoader();

    })
  }


  sortByMsg(list: Array<any>, prop: string) {
    if (list != null && list.length > 0) {
      return list.sort((a, b) => {
        return <any>new Date(a[prop]) - <any>new Date(b[prop]);
      });
    }
  }

  onModalScrollDown() {
    this.currentPageCount += 1;
    this.startCount = this.currentPageCount;
    this.currentIndex = this.currentPageCount;
    if (this.startCount != 0) {
      this.messageListQuery(this.messageDataPass.recipientId, "", '');
    }
  }

  userDetails(value) {
    if (value != null) {
      var id: any;
      if (value.createdBy !=null && value.createdBy  != this.loginUserData.userId) {
        id = value.createdBy;
      }if (value.jobPostedBy  !=null && value.jobPostedBy != this.loginUserData.userId) {
        id = value.jobPostedBy;
      } else if( value.groupOwner != null) {
        id = value.groupOwner;
      }else{
        id = value.groupId;
      }


      this.api.query("user/" + id).subscribe((ress) => {
        if (ress != undefined && ress.code == "00000") {
          this.photo = ress.photo;
          if (ress.photo != null) {
            // Use getPhotoUrl to avoid URL duplication
            ress.photo = this.getPhotoUrl(ress.photo);
          }
          // No else needed - template handles initials when photo is null
          this.userData = ress;
        }
      });
    } else {
      this.api.query("user/" + this.messageDataPass.userId).subscribe((res) => {
        if (res != undefined && res.code == "00000") {
          this.photo = res.photo;
          if (res.photo != null) {
            // Use getPhotoUrl to avoid URL duplication
            res.photo = this.getPhotoUrl(res.photo);
          }
          // No else needed - template handles initials when photo is null
          this.userData = res;
        }
      });
    }

  }

  private updateNonSeenMessage(message: any) {
    let id = localStorage.getItem('userId');
    let url = "message/seen/" + id;
    //this._socket.send(url, message);
    this.api.messagePageService('PUT', url, message).subscribe(res => {
      if (res) { }
    });
  }



  closemodel() {
    this.closeMessageModel.emit(this.messageDataPass);
    if (this.topicMessageSub) {
      this.topicMessageSub.unsubscribe();
    }

    if (this.topic_newcontacts_Subscribe) {
      this.topic_newcontacts_Subscribe.unsubscribe();
    }



  }
  minimize() {
    this.closeMessageModel.emit(this.messageDataPass);
    if (this.topicMessageSub) {
      this.topicMessageSub.unsubscribe();
    }
    if (this.topic_newcontacts_Subscribe) {
        this.topic_newcontacts_Subscribe.unsubscribe();
    }
}



  sendmessage() {
    if (this.isMessageBlank) {
      return;
    }
    this.util.startLoader();
    if (typeof this.sendMessageData['message'] === 'string') {
      this.sendMessageData['message'] = this.sendMessageData['message'].replace(/&nbsp;|<\/?[^>]+(>|$)/g, "").trim();
    }

    this.loaderstartstop=true;
    this.disableSendmsg=true;
    this.sendMessageData['authorId'] = localStorage.getItem('userId');
    this.sendMessageData['recipientId'] = this.messageDataPass.recipientId;
    this.sendMessageData['userType'] = this.messageDataPass.groupType;
    this.sendMessageData['enableDelete'] = true;
    this.sendMessageData['messageType'] = this.messageDataPass.messageType;
    this.sendMessageData['refererId'] = this.messageDataPass.id;
    if (this.messageDataPass.groupType == "USER") {
      this.sendMessageData.recipientId = this.messageDataPass.recipientId;
      delete this.sendMessageData.refererId;

      if(this.messageDataPass.onlyuser!=undefined &&this.messageDataPass.onlyuser=="USER"){
        this.sendMessageData.recipientId= this.messageDataPass.userId;
        this.sendMessageData.refererId= this.messageDataPass.userId;
      }

    }
    const url = 'message/send';
    this.api.messagePageService('POST', url, this.sendMessageData).pipe(
      catchError((error) => {
        // Handle the error here
        console.error('An error occurred:', error);
        this.util.stopLoader();
        this.loaderstartstop = false;
        this.disableSendmsg = false;
        // Optionally, return a fallback value or an observable to recover
        return of(null); // You can replace null with a more meaningful fallback if necessary
      })
    ).subscribe(res => {
      if (!res) {
        // If catchError returned null, there might not be a response to process.
        // Handle this scenario appropriately.
        return;
      }
      this.util.stopLoader();
      this.loaderstartstop=false;
      this.disableSendmsg=false;

      if (this.exits == false) {
        res.groupId = res.recipientId;
        this.topic_message_recive(res);
        this.exits = true;
      }
      this.sendMessageData = {};
      this.sendMessageData['message'] = {};
      this.messageDataPass.recipientId = res.recipientId;
      res.authorName = this.loginUserData.firstName + " " + this.loginUserData.lastName;
      res.authorPhoto = this.loginUserData.photo;
      this.messageList.push(res);
      this.updateScoll();
      // this.autofocusSendmsg.nativeElement.click();
    });



  }


  ngOnDestroy() {
    this.unregisterDropzoneCatchAll();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.onlinestatus) {
      this.onlinestatus.unsubscribe();
    }
    if (this.topic_contacts_Subscribe) {
      this.topic_contacts_Subscribe.unsubscribe();
    }
    if (this.topic_newcontacts_Subscribe) {
      this.topic_newcontacts_Subscribe.unsubscribe();
    }
    if (this.topicMessageSub) {
      this.topicMessageSub.unsubscribe();
    }
    if (this.streamsubscription) {
      this.streamsubscription.unsubscribe();
    }
    if(this.socketTopicmessageMSG11){
      this.socketTopicmessageMSG11.unsubscribe();
     }

    // this.subscriptionsList.forEach(subscription => subscription.unsubscribe());

  }


}



